import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IFloorPlan } from '../../types/floorPlan';

const initialState: IFloorPlan = {
  isOpened: false,
  houseId: null,
};

/* istanbul ignore next */
const floorPlanSlice = createSlice({
  initialState,
  name: 'floorPlan',
  reducers: {
    setOpenFloorPlan: (state, action: PayloadAction<boolean>) => {
      state.isOpened = action.payload;
    },
    setFloorPlanHouseId: (state, action: PayloadAction<number | null>) => {
      state.houseId = action.payload;
    },
  },
});

export const {
  reducer: floorPlanReducer,
  actions: { setOpenFloorPlan, setFloorPlanHouseId },
} = floorPlanSlice;
